import { render, staticRenderFns } from "./TxTileLayer.vue?vue&type=template&id=04705c4c&scoped=true&"
import script from "./TxTileLayer.vue?vue&type=script&lang=js&"
export * from "./TxTileLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04705c4c",
  null
  
)

export default component.exports